// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
Vue.use(Vuex)
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'

Vue.use(ElementUI)
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    inline: false,
    button: true, // 右上角按钮
    navbar: true, // 底部缩略图
    title: false, // 当前图片标题
    toolbar: false, // 底部工具栏
    tooltip: false, // 显示缩放百分比
    movable: true, // 是否可以移动
    zoomable: true, // 是否可以缩放
    rotatable: true, // 是否可旋转
    scalable: true, // 是否可翻转
    transition: true, // 使用 CSS3 过度
    fullscreen: true, // 播放时是否全屏
    keyboard: false, // 是否支持键盘
    url: 'data-large' // 大图
  }
})

import '@/permission'
// import 'signalr'
import '@/utils/directives.js'
import * as socketApi from '@/utils/socket.js'
import validate from '@/utils/validate.js'; //全局表单验证

Vue.prototype.$validate = validate;
Vue.prototype.socketApi = socketApi

// import './mock' // simulation data

// css
import '@/assets/styles/index.css'

Vue.config.productionTip = false

// 过滤 mpegts.js 销毁时的良性错误（播放器destroy后内部异步回调仍在执行）
window.addEventListener('unhandledrejection', function(e) {
  if (e.reason && e.reason.message && e.reason.message.indexOf("Cannot read properties of null") !== -1) {
    e.preventDefault()
  }
})
window.addEventListener('error', function(e) {
  if (e.message && e.message.indexOf("Cannot read properties of null") !== -1 &&
      (e.message.indexOf('emit') !== -1 || e.message.indexOf('notifyBufferedPositionChanged') !== -1)) {
    e.preventDefault()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app_index',
  store,
  router,
  components: { App },
  template: '<App/>'
})

document.title = process.env.SystemName || '博思高云坐席'



// WEBPACK FOOTER //
// ./src/main.js